<template>
  <div class="container application">
    <div class="term-desc" />
    <h3 class="page-title sub">{{ userName }}<small>님은</small></h3>
    <h2 class="mt-1">보증 대상자 입니다.</h2>
    <div class="content">
      <small>신청하신 차종과 대여기간, 신용점수를 고려하여 보증단계를 진행합니다.</small><br>
      <small>보증금을 입금해주세요.</small>
    </div>

    <div class="input-item">
      <div class="input-label">보증방법</div>
      <div :class="{ error: hasError(errors, '보증방법')}">
        <small>보증금</small>
      </div>
    </div>

    <div class="blue050 mt-2">
      <small>
        아래의 보증금은 계약 완료 후 24시간 안에 입금해주세요. 입금자 명의는 계약자 본인이어야 합니다.<br>
        [보증금 입금 정보: 신한은행 100-033-911772 / 예금주: 주식회사 쏘카]<br>
        ※쏘카플랜 대여를 위한 결제가 완료되더라도, 계약 완료 후 24시간 안에 보증금 입금이 완료되어야 차량이 인도됩니다.<br>
        ※보증조건이 충족되지 않아 계약이 취소된 경우, 취소 정책에 따라 취소 수수료가 발생할 수 있습니다.
      </small>
    </div>

    <div class="warranty-deposit-area mt-2">
      <div class="input-item">
        <div class="input-label">보증 적용 비율</div>
        <input
          name="warrantyDeposit"
          class="form-field"
          type="text"
          :value="`${warrantyPercent}%`"
          :disabled="true"
        >
      </div>

      <div class="input-item mt-2">
        <div class="input-label">보증금</div>
        <input
          name="warrantyDeposit"
          class="form-field"
          type="text"
          :value="formatNumber(warrantyDeposit)"
          :disabled="true"
        >
      </div>
    </div>

    <vs-row class="form-group submit mb-2">
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full btn_outline"
          @click.prevent="back"
        >
          이전
        </button>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="bottom-button">
        <button
          type="submit"
          class="btn btn_lg btn_full"
          :disabled="!valid"
          @click.prevent="next"
        >
          다음
        </button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import HorizontalRadio from 'components/HorizontalRadio';
import * as amplitude from '@amplitude/analytics-browser';

export default {
  name: 'Step03',
  components: {
    HorizontalRadio,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    warrantyTypes: {
      type: Array,
      default: () => ([]),
    },
    warrantyPercent: {
      type: Number,
      required: true,
    },
    warrantyDeposit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      warrantyType: this.data.warrantyType || 'WRTTY_DEPOSIT',
    };
  },
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    valid() {
      return !isEmpty(this.warrantyType);
    },
  },
  created() {
    const { regionGroup, carType, carTypeId, prepaidRate } = this.data;
    const args = {
      page_name: 'plan_contract_2_need_deposit',
      event_label: regionGroup.id || '',
      event_category: document.title,
      page_url: document.URL,
      component_state: prepaidRate === 0 ? '' : `prepayments_${prepaidRate * 100}%`,
      component_type: carType.thumbnailTags.map(({ id }) => id).join(','),
      component_category: carType.carClassTag.id || '',
      component_id: carTypeId,
      service_type: carType.benefitTags.map(({ id }) => id).join(','),
    };
    this.$gtag.event('view', args);
  },
  methods: {
    next() {
      const { contractId } = this.data;
      const args = {
        page_name: 'plan_car_contract',
        event_category: document.title,
        page_url: document.URL,
        component_name: 'plan_check_need_deposit_next_button',
        reservation_id: contractId,
      };
      this.$gtag.event('click', args);
      amplitude.logEvent('click', args);

      const warrantyType = this.warrantyType;
      this.$emit('next', { warrantyType });
    },
    back() {
      this.$emit('back');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
